// src/app/ProjectImage.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectImage } from  '../objects/Project';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjectImageService {
    
  private apiUrl = environment.apiUrl +'ProjectImages'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  GetProjectImage(): Observable<ProjectImage[]> {
    return this.http.get<ProjectImage[]>(this.apiUrl);
  }

  
  getImage(id:number): Observable<ProjectImage> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<ProjectImage>(url);
  }



  addImage(Image: ProjectImage): Observable<ProjectImage> {
    return this.http.post<ProjectImage>(this.apiUrl, Image);
  }

  editImage(Image: ProjectImage): Observable<ProjectImage> {
    const url = `${this.apiUrl}/${Image.id}`;
    return this.http.put<ProjectImage>(url, Image);
  }
  deleteImage(Image: ProjectImage): Observable<ProjectImage> {
    const url = `${this.apiUrl}/${Image.id}`;
    return this.http.delete<ProjectImage>(url);
  }
}
